// extracted by mini-css-extract-plugin
module.exports = {"hafnv4b":"hafnv4b","ti5goar":"ti5goar","t4y0n8":"t4y0n8","name":"name"};